import ___default from "lodash";
const isValidJobProfileSideStreamTriggerFilterForm = (values) => {
  let errors = {};
  if (values.isJobProfileSideStreamEnabled && values.jobProfileSideStreamCustomParameters.length > 0) {
    errors.jobProfileSideStreamCustomParameters = ___default.map(
      values.jobProfileSideStreamCustomParameters,
      (jobProfileSideStreamCustomParameter) => {
        let customParameterError = {};
        if (!jobProfileSideStreamCustomParameter.type) {
          customParameterError.type = "Required";
        }
        if (!jobProfileSideStreamCustomParameter.name) {
          customParameterError.name = "Required";
        }
        if (!jobProfileSideStreamCustomParameter.value) {
          customParameterError.value = "Required";
        }
        return customParameterError;
      }
    );
    if (!___default.some(errors.jobProfileSideStreamCustomParameters, (s) => !!s.value)) {
      delete errors.jobProfileSideStreamCustomParameters;
    }
  } else {
    delete errors.jobProfileSideStreamCustomParameters;
  }
  return errors;
};
export {
  isValidJobProfileSideStreamTriggerFilterForm
};
//# sourceMappingURL=JobProfileSideStreamTriggerForm.validation.js.map
